import React, { useEffect, useMemo, useState } from 'react'
import { Box, Typography } from '@mui/material'
import SmartSearch from '../formComponent/Search'
import SmartPaletteSection from '../smartPalette/SmartPaletteSection'
import { useSmartTranslation } from '../hooks/useSmartTranslation'
import SmartDraggableItem from './SmartDraggableItem'
const UngroupedItemsSection = ({ items, customStyle }) => {
  const [filterTextUngrouped, setFilterTextUngrouped] = useState('')
  const [filteredUngrouped, setFilteredUngrouped] = useState([])
  const { t_ } = useSmartTranslation()
  useEffect(() => {
    if (!items || !items.ungrouped) {
      setFilteredUngrouped([])
      return
    }

    const filtered = items.ungrouped.filter(item =>
      item.text.toLowerCase().includes(filterTextUngrouped.toLowerCase())
    )
    setFilteredUngrouped(filtered)
  }, [items, filterTextUngrouped])
  const renderUngroupedItem = ({ item }) => (
    <SmartDraggableItem key={item.tempId} id={item.tempId} data={{ item }} customStyle={customStyle}>
      {item.text}
    </SmartDraggableItem>
  )

  const memoizedSection = useMemo(() => ({
    items: filteredUngrouped
  }), [filteredUngrouped])

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <Typography variant='h6'>{t_('Features')}</Typography>
        <SmartSearch
          setFilterText={setFilterTextUngrouped}
          setWidth='50%'
          setLoadTable={() => true}
          loadTable
        />
      </div>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        {filteredUngrouped.length > 0
          ? (
            <SmartPaletteSection
              section={memoizedSection}
              renderItem={renderUngroupedItem}
              getLabel={(section, item) => item.text}
              pageable
              itemsPerPage={5}
            />
            )
          : (
            <Typography>{t_('No data to display')}</Typography>
            )}
      </Box>
    </div>
  )
}
export default UngroupedItemsSection
